import { useState, useEffect } from 'react';
import API from '../services/api';

/**
 * Hook to fetch company and department options
 * Reuses the same logic from UserProfile.js
 */
export const useCompanyDepartmentOptions = () => {
 const [companies, setCompanies] = useState([]);
 const [departments, setDepartments] = useState([]);
 const [loading, setLoading] = useState(true);
 const [error, setError] = useState(null);

 // Fallback departments list (same as UserProfile.js)
 const fallbackDepartments = [
 "Ban Chủ Tịch",
 "Ban Giám Đốc", 
 "Phòng Kế Toán",
 "Phòng Hành chính - Nhân sự",
 "Phòng Kỹ Thuật",
 "Phòng Phụ tùng",
 "Phòng Tổng Hợp",
 "Phòng Dự án",
 "Phòng Kinh Doanh"
 ];

 // Fallback companies list (same as UserProfile.js)
 const fallbackCompanies = [
 "Công ty Cổ Phần Thương Mại Quốc Tế Tân Đại Tây Dương",
 "Công ty Cổ Phần Sản Xuất Thiết Bị Công Nghiệp Nặng Việt Nam",
 "Công ty Cổ Phần TVN Global"
 ];

 const fetchOptions = async () => {
 setLoading(true);
 setError(null);

 try {
 // Fetch companies
 try {
 const companiesRes = await API.get('/users2/companies', { timeout: 5000 });
 setCompanies(companiesRes.data.companies || fallbackCompanies);
 } catch (companyError) {
 console.warn('Không thể tải danh sách công ty:', companyError);
 setCompanies(fallbackCompanies);
 }

 // Fetch departments
 try {
 const departmentsRes = await API.get('/system-config/departments', { timeout: 5000 });
 setDepartments(departmentsRes.data.departments || fallbackDepartments);
 } catch (departmentError) {
 console.warn('Không thể tải danh sách phòng ban:', departmentError);
 setDepartments(fallbackDepartments);
 }
 } catch (error) {
 console.error('Error fetching company/department options:', error);
 setError(error);
 // Use fallback data
 setCompanies(fallbackCompanies);
 setDepartments(fallbackDepartments);
 } finally {
 setLoading(false);
 }
 };

 useEffect(() => {
 // Check if we're on complete-profile page to avoid API calls that might trigger middleware
 const isCompleteProfilePage = window.location.pathname === '/complete-profile';

 if (isCompleteProfilePage) {
 console.log('[COMPANY OPTIONS] On complete-profile page, using fallback data only');
 setCompanies(fallbackCompanies);
 setDepartments(fallbackDepartments);
 setLoading(false);
 } else {
 fetchOptions();
 }
 }, []);

 const refetch = () => {
 fetchOptions();
 };

 return {
 companies,
 departments,
 loading,
 error,
 refetch,
 fallbackCompanies,
 fallbackDepartments
 };
};

export default useCompanyDepartmentOptions;
